<template>
  <component v-for="item in Object.keys(modal)"
             :ref="item" :is="modal[item]" />
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Modal from '@controller/modal';

export default {
  name: 'page_modal',
  data(): DataInterface {
    return {
      modal: Modal
    };
  },
  mounted(): void {
    this.init();
  },
  methods: {
    /**
     * 初始化
     */
    init(): void {
      let modal = {};
      
      Object.keys(this.$refs)
        .forEach((v: string) => {
          const item = this.$refs[v][0];
          
          modal[v] = {
            open: (data: any = null) => {
              item.open?.(data);
            },
            close: (data: any = null) => {
              item.close?.(data);
            }
          };
        });
      
      $Store.Page().updateModal(modal);
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
</style>